/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Settings_Reportingapikeys_Deactivateall_Activekeys4Inputs */

const en_settings_reportingapikeys_deactivateall_activekeys4 = /** @type {(inputs: Settings_Reportingapikeys_Deactivateall_Activekeys4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Active keys that will be deactivated (${i?.count}):`)
};

/**
* | output |
* | --- |
* | "Active keys that will be deactivated ({count}):" |
*
* @param {Settings_Reportingapikeys_Deactivateall_Activekeys4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_deactivateall_activekeys4 = /** @type {((inputs: Settings_Reportingapikeys_Deactivateall_Activekeys4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Deactivateall_Activekeys4Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_deactivateall_activekeys4(inputs)
});
export { settings_reportingapikeys_deactivateall_activekeys4 as "settings_reportingApiKeys_deactivateAll_activeKeys" }